import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'

import * as config from '@/config'
import store from '@/stores/store-authen'

Vue.use(VueRouter)

const guard = function(to, from, next) {
	if (!store.getters.isInitted) {
    	store.dispatch('initAuthUser')
			.then(() => {
				if ((store.getters.isInitted) && (!store.getters.isAuthenticated)) {
					router.push(`/login?redirect=${to.path}`)
				}
				next()
			})
	} else {
		next()
	}
}

const routes = [
	{
		path: `/`,
		name: 'home',
		component: Home,
		meta: {
			title: 'Happy new year 2020'
		}
	},
	{
		path: `/login`,
		name: 'login',
		component: () => import('@/views/Login.vue'),
		meta: {
			title: 'Login to Jeban.com'
		}
	},
	{
		path: `/new`,
		name: 'addWish',
		component: () => import('@/views/Create.vue'),
		meta: {
			title: 'Make A Wish'
		},
		beforeEnter: (to, from, next) => {
			guard(to, from, next)
		}
	},
	{
		path: `/pick-reward`,
		name: 'pickReward',
		component: () => import('@/views/PickReward.vue'),
		meta: {
			title: 'Pick A Reward'
		},
		beforeEnter: (to, from, next) => {
			guard(to, from, next)
		}
	},
	{
		path: `/by/:userId`,
		name: 'Dashboard',
		component: () => import('@/views/Dashboard.vue'),
		meta: {
			title: 'My Wishes'
		},
		beforeEnter: (to, from, next) => {
			guard(to, from, next)
		}
	},
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

router.beforeEach((to, from, next) => {
	document.title = to.meta.title
	next()
})

export default router
